import { SettingsCard, TextField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function KurumsalBilgiler({ settings, update }: SettingsTabProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SettingsCard
        title="Şirket Bilgileri"
        description="Yasal unvan, vergi ve ticaret sicil bilgileri. Bu bilgiler faturalarda ve yasal sayfalarda kullanılır."
      >
        <div className="space-y-4">
          <TextField
            label="Kurumsal Ad (Görünen)"
            value={settings.companyName}
            onChange={(v) => update({ companyName: v })}
            placeholder="Örn. Dersdinle Eğitim Teknolojileri A.Ş."
          />
          <TextField
            label="Yasal Unvan"
            value={settings.legalName}
            onChange={(v) => update({ legalName: v })}
            placeholder="Tam yasal şirket unvanı"
          />
          <div className="grid grid-cols-2 gap-4">
            <TextField
              label="Vergi Dairesi"
              value={settings.taxOffice}
              onChange={(v) => update({ taxOffice: v })}
              placeholder="Örn. Kadıköy"
            />
            <TextField
              label="Vergi No"
              value={settings.taxNumber}
              onChange={(v) => update({ taxNumber: v })}
              placeholder="Vergi kimlik numarası"
            />
          </div>
          <TextField
            label="Ticaret Sicil No"
            value={settings.tradeRegistry}
            onChange={(v) => update({ tradeRegistry: v })}
            placeholder="Ticaret sicil / MERSİS numarası"
          />
        </div>
      </SettingsCard>

      <SettingsCard
        title="Adres & Lokasyon"
        description="Merkez adresi ve posta bilgileri. İletişim sayfası ve yerel SEO için kullanılır."
      >
        <div className="space-y-4">
          <TextField
            label="Açık Adres"
            value={settings.address}
            onChange={(v) => update({ address: v })}
            placeholder="Mahalle, cadde, sokak, no"
          />
          <div className="grid grid-cols-2 gap-4">
            <TextField
              label="Şehir"
              value={settings.city}
              onChange={(v) => update({ city: v })}
              placeholder="Örn. İstanbul"
            />
            <TextField
              label="Posta Kodu"
              value={settings.postalCode}
              onChange={(v) => update({ postalCode: v })}
              placeholder="Örn. 34710"
            />
          </div>
          <div className="rounded-md bg-accent-100/70 px-4 py-3 text-xs text-accent-900">
            <i className="ri-information-line mr-1" aria-hidden="true"></i>
            Bu bilgiler otomatik olarak iletişim ve KVKK sayfalarına yansıtılır.
          </div>
        </div>
      </SettingsCard>
    </div>
  );
}